import React from "react";

import * as C from "./Card.styles.js";

const Card = ({ pizza, index, onClick }) => {
  return (
    <C.CardContainer onClick={onClick}>
      <C.PizzaInformation className={pizza.image === "" ? "full-width" : ""} >
        <C.PizzaName>{index < 10 ? `0${index}` : index} - {pizza.nome}</C.PizzaName>
        <C.PizzaIngredients>{pizza.ingredientes}</C.PizzaIngredients>
        <C.PizzaPrice>R$ {pizza.valor},00</C.PizzaPrice>
      </C.PizzaInformation>
      {
        pizza.image !== "" &&
        <C.ImageContainer>
          <C.ImagePizza src={pizza.image} alt="Imagem da Pizza" loading="lazy" />
        </C.ImageContainer>
      }
    </C.CardContainer>
  );
}

export default Card;
